import edap from '../edap';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import {ImageCarousel} from '../../components/image-carousel';
import ListingLocation from './listing-location';
import ListingPrice, {LISTING_STATUS} from './listing-price';
import ListingReviews from './listing-reviews';
import ListingRooms from './listing-rooms';
import PdpButton from './listing-pdp-button';
import React, {Component} from 'react';
import {UnavailableLabel} from '../unavailable-label';
import './listing-preview.less';

/* istanbul ignore next */


export class ListingPreview extends Component {

    constructor(props) {
        super(props);
        this.state = {
            carouselIndex: 0
        };
    }

    onCarouselArrowClick = (direction, index) => {
        edap.carouselCommentsArrowClick(direction);
        this.setState({carouselIndex: index});
    }

    onPdpClick = () => {
        const {boardId, endDate, listingId, startDate} = this.props;
        edap.viewProperty(boardId, endDate, listingId, startDate, this.state.carouselIndex, this.props.images.length);
    }

    render() {
        const {
            availableForDates,
            averagePrice,
            averageRating,
            baseLocation,
            bathrooms,
            bedrooms,
            detailPageUrl,
            hasCarousel,
            headline,
            images,
            isMobile = true,
            priceSummary,
            reviewCount,
            sleeps,
            size,
            status,
            stay
        } = this.props;


        const img = Array.isArray(images) ? images[0] || {} : {};
        const isUnavailable = (status === LISTING_STATUS.UNAVAILABLE) || (stay && !availableForDates);
        const showCarousel = hasCarousel && images.length > 1;

        return (
            <div className="listing-preview">
                <div className="listing-preview__body">
                    <div className="listing-preview__images">
                        {isUnavailable && <UnavailableLabel />}
                        {showCarousel &&
                            <ImageCarousel
                                images={images}
                                isMobile={isMobile}
                                onCarouselArrowClick={this.onCarouselArrowClick}
                                renderButtonCircle
                                showPageNumber
                                slideSize={isMobile ? 'cover' : 'height'}
                            />
                        }
                        {!showCarousel &&
                            <img
                                alt=""
                                className={`listing-preview__image ${size || ''}`}
                                src={isMobile ? img.lowResSrc : img.src}
                            />
                        }
                    </div>
                    <div className="listing-preview__details">
                        <ListingLocation baseLocation={baseLocation} />
                        <h3 className="listing-preview__headline">{headline}</h3>
                        {isMobile &&
                            <div className="listing-preview__price">
                                <ListingPrice
                                    availableForDates={availableForDates}
                                    averagePrice={averagePrice}
                                    priceSummary={priceSummary}
                                    stay={stay}
                                    status={status}
                                />
                            </div>
                        }
                        <div className="listing-preview__reviews">
                            <ListingReviews
                                averageRating={averageRating}
                                reviewCount={reviewCount}
                            />
                        </div>
                        <div className="listing-preview__rooms">
                            <ListingRooms
                                bathrooms={bathrooms}
                                bedrooms={bedrooms}
                                sleeps={sleeps}
                            />
                        </div>
                    </div>
                </div>
                <div className="listing-preview__footer">
                    <div className="listing-preview__price-footer">
                        <ListingPrice
                            availableForDates={availableForDates}
                            averagePrice={averagePrice}
                            priceSummary={priceSummary}
                            stay={stay}
                            status={status}
                        />
                    </div>
                    <div className="listing-preview__pdp-btn-footer">
                        <PdpButton
                            detailPageUrl={detailPageUrl}
                            size="sm"
                            onClick={this.onPdpClick}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default determineIfMobile(ListingPreview);



// WEBPACK FOOTER //
// ./src/universal/tripboard/listing/listing-preview.js